module.exports = __webpack_public_path__ + "img/task-group.abd5ba2d.png";